import * as React from 'react'
import {ComponentExt} from '@utils/reactExt'
import CRouterG from '@router/routerG'
export default class App extends ComponentExt<any> {

    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <CRouterG location={this.props.location} />
        )
    }
}
